import { i18n } from '@/lang/index.js'
import { addTraceStore } from '@/utils/storage.js'
import { getQueryParams } from '@/utils/common.js'
import { appNameFlag, domainNameFlag } from '@/assets/scripts/judge-package-name.js'

import moment from 'moment'
import Decimal from 'decimal.js'
import BaseConfig from '@/config/base.js'
import Client from '@/assets/scripts/client'

// 多包名称相同资源，不同设计
import allImgs from '@/assets/packageAssets/packages/index.js'

// 多包words 不同表示
import getWords from '@/assets/packageAssets/words/index.js'

function isEmpty(val) {
  return val === undefined || val === null || val === ''
}

// 默认顶部栏padding-top
const defaultBarH = 38
// 默认底部栏
const defaultBottomBarH = 0

// prettier-ignore
const GlobalMixins = {
  data() {
    return {
      isVest: false,
      packageName: '',
      domain: window.location.hostname,
      // CDN图片路径
      imgHost: BaseConfig.imgHost,
      // CDN文件路径
      packageHost: BaseConfig.imgHost,
      // 沉浸式页面设置高度
      barHeight: defaultBarH,
      bottomBarHeight: defaultBottomBarH,
      rtlLangs: [...BaseConfig.rtlLangs],
      incomeType: [
        {
          id: null,
          text: i18n.t('lang.all')
        },
        {
          id: 2,
          text: i18n.t('lang.mybean.gift')
        },
        {
          id: 3,
          text: i18n.t('lang.mybean.privateCalls')
        },
        {
          id: 5,
          text: i18n.t('lang.mybean.matchCalls')
        },
        {
          id: 6,
          text: i18n.t('lang.mybean.others')
        },
        {
          id: 15,
          text: i18n.t('lang.mybean.message')
        },

        {
          id: 16,
          text: i18n.t('lang.mybean.bonus')
        },

        {
          id: 18,
          text: i18n.t('lang.mybean.weeklyBonus')
        }
      ],
      // 全局权益
      propsMap: {
        0: 'coin',
        1: 'chat-pass',
        2: 'video-pass',
        3: 'beans',
        4: 'vip',
        5: '?',
        6: 'call-pass',
        7: 'beer',
        8: '?',
        9: 'coupon',
        10: '?',
        15: 'super-chat-pass'
      }
    }
  },
  computed: {
    env() {
      let ua = navigator.userAgent
      let isAppIOS = false
      let isAppAndroid = false

      try {
        isAppIOS = this.$client.getAppInfo().deviceType === '1'
        isAppAndroid = this.$client.getAppInfo().deviceType === '0'
      } catch (err) {
        console.log('try catch err:', err)
      }

      return {
        // ua在app内 值是dq
        ua: ua,
        // app内可判断
        isApp: /dq/i.test(ua),
        isBrowser: !/dq/i.test(ua),
        isAppIOS: isAppIOS,
        isAppAndroid: isAppAndroid,
        // app外可判断
        isMobile: /android|iphone|ipod|ipad/i.test(ua),
        isIOS: /iphone|ipod|ipad|ios|mac os/i.test(ua),
        isAndroid: /android/i.test(ua)
      }
    },
    uid() {
      let USERINFO = this.$client.getUserBaseInfo()
      return USERINFO && USERINFO['uid'] ? USERINFO['uid'] : ''
    }
  },
  watch: {
    $route: {
      handler(newRoute, oldRoute) {
        let tempH = defaultBarH
        let tempBottomH = defaultBottomBarH
        try {
          if (newRoute) {
            // 处理顶部安全区
            let statusBarHeight = newRoute.query.statusBarHeight
            if (statusBarHeight) {
              window.sessionStorage.setItem('clientBarH', statusBarHeight)
              tempH = statusBarHeight ? statusBarHeight * 1 : defaultBarH
            }
            // url无
            else {
              const clientBarH = window.sessionStorage.getItem('clientBarH')
              if (clientBarH) {
                tempH = clientBarH * 1
              }
            }

            // 处理底部安全区
            let bottomBarHeight = newRoute.query.bottomBarHeight
            if (bottomBarHeight) {
              window.sessionStorage.setItem('clientBottomH', bottomBarHeight)
              tempBottomH = bottomBarHeight ? bottomBarHeight * 1 : defaultBottomBarH
            }
            // url无
            else {
              const clientBottomH = window.sessionStorage.getItem('clientBottomH')
              if (clientBottomH) {
                bottomBarHeight = clientBottomH * 1
                tempBottomH = bottomBarHeight
              }
            }
            setTimeout(() => {
              const bottomBarDoms = document.querySelectorAll('.bottomBarHeight')
              if (!bottomBarDoms.length && bottomBarHeight) {
                const targetDom = document.querySelectorAll('.containerIndex')
                if (targetDom && targetDom.length === 1) {
                  const tempDom = document.createElement('div')
                  tempDom.className = 'bottomBarHeight'
                  tempDom.style.width = '100%'
                  tempDom.style.height = `${bottomBarHeight}px`
                  targetDom[0].append(tempDom)
                }
              }
            })
          }
        } catch (err) {
          console.log('try catch', err)
        }
        // 顶部安全区
        this.barHeight = tempH
        this.bottomBarHeight = tempBottomH
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 区分包-包名
    appNameFlag: appNameFlag,

    // 区分包-域名
    domainNameFlag: domainNameFlag,

    // 获取uid
    getUid() {
      return this.$client.getUserBaseInfo().uid
    },

    getChannel() {
      return this.$client.getAppInfo().channel
    },

    getAppName() {
      return this.$client.getAppInfo().appPackageName
    },

    // 获取简单包名
    getPackageName() {
      const appName = this.getAppName()
      const appArray = BaseConfig.validPackage
      for (let i = 0; i < appArray.length + 1; i++) {
        const tempName = appArray[i]
        if (this.appNameFlag(tempName, appName) || this.domainNameFlag(tempName, this.domain)) {
          this.packageName = tempName
          break
        }
      }
    },

    getMatchImg(imgname, pkgName) {
      try {
        if (pkgName) {
          return allImgs[pkgName][imgname]
        }
  
        let imgResult = null
        const appName = this.getAppName()
        const appArray = BaseConfig.validPackage
  
        for (let i = 0; i < appArray.length + 1; i++) {
          const tempName = appArray[i]
          if (this.appNameFlag(tempName, appName) || this.domainNameFlag(tempName, this.domain)) {
            imgResult = allImgs[tempName][imgname]
            break
          }
        }
  
        return imgResult
      }
      // 
      catch (err) {
        return ''
      }
    },

    getMatchAddress() {
      let downloadAddress = null
      const appName = this.getAppName()
      const appArray = BaseConfig.validPackage

      for (let i = 0; i < appArray.length + 1; i++) {
        const tempName = appArray[i]
        if (this.appNameFlag(tempName, appName) || this.domainNameFlag(tempName, this.domain)) {
          downloadAddress = BaseConfig[`${tempName}Address`]
          break
        }
      }

      return downloadAddress
    },

    // 替换多语言不同包文案
    $rt(keyname, argsObj) {
      let textResult = ''
      const appName = this.getAppName()
      const appArray = BaseConfig.validPackage

      for (let i = 0; i < appArray.length + 1; i++) {
        const tempName = appArray[i]
        if (this.appNameFlag(tempName, appName) || this.domainNameFlag(tempName, this.domain)) {
          const tempWordsObj = getWords(tempName)
          textResult = i18n.t(keyname, { ...argsObj, ...tempWordsObj })
          break
        }
      }

      return textResult
    },

    // 跳转app
    appAction(path = '', query = '') {
      if (path) {
        let schemaHead = BaseConfig.schemaMap.default
        let pathMap = BaseConfig.defaultClientPath

        const appName = this.getAppName()
        const appArray = BaseConfig.validPackage
        for (let i = 0; i < appArray.length + 1; i++) {
          const tempName = appArray[i]
          if (this.appNameFlag(tempName, appName) || this.domainNameFlag(tempName, this.domain)) {
            schemaHead = BaseConfig.schemaMap[tempName]
            pathMap = BaseConfig[`${tempName}ClientPath`]
            break
          }
        }

        if (pathMap && pathMap[path]) {
          commandRouter.postMessage(`${schemaHead}${pathMap[path]}${query}`)
        }
        //
        else {
          commandRouter.postMessage(path)
        }
      }
    },

    appActionPro(url = '', addQuery = {}) {
      try {
        const open_web_inside_arr = []
        const BaseConfigKeys = Object.keys(BaseConfig)
        if (Array.isArray(BaseConfigKeys)) {
          BaseConfigKeys.forEach((key) => {
            if (key.indexOf('ClientPath') > -1 && BaseConfig[key]['open_web_inside']) {
              open_web_inside_arr.push(BaseConfig[key]['open_web_inside'])
            }
          })
        }
        let isTargetPath = false
        for (let i = 0; i < open_web_inside_arr.length; i++) {
          if (url.indexOf(open_web_inside_arr[i]) > -1) {
            isTargetPath = true
            break
          }
        }

        // 是open_web_inside
        if (isTargetPath) {
          // imee://open_web_inside?url=xxxx?p1=xx&p2=xx
          let realUrl = ''
          let tIndex = url.indexOf('?')
          if (tIndex > -1 && url[tIndex + 1]) {
            realUrl = url.substring(tIndex + 1)
          }
          if (realUrl) {
            let realUrlArr = realUrl.split('?')
            if (realUrlArr.length > 1) {
              const originQuery = getQueryParams(realUrlArr)
              const toUrl = realUrlArr[0].replace('url=', '')
              this.$router.push({ path: toUrl, query: { ...originQuery, ...addQuery } })
            }
            //
            else {
              const toUrl = realUrl.replace('url=', '')
              this.$router.push({ path: toUrl, query: addQuery })
            }
          }
        }
        // 非open_web_inside
        else {
          console.log('🚀 ~ commandRouter.postMessage:', url)
          commandRouter.postMessage(url)
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
    },

    // 关闭
    closeWeb() {
      // app内 关闭webview
      if (this.env.isApp) {
        // ios
        if (this.env.isAppIOS) {
          this.$client.closeActivityIOS()
        }
        // 非ios
        else {
          this.$client.closeActivity()
        }
        return
      }

      // app外 返回上一页
      this.$router.go(-1)
    },

    // 回退
    goPrevious() {
      if (this.$route.query.backType === 'close') {
        this.closeWeb()
        return
      }

      this.$router.go(-1)
    },

    goBack() {
      if (this.$route.query.backType === 'previous') {
        this.$router.go(-1)
        return
      }

      this.closeWeb()
    },

    // 返回按钮IOS 过包用 用户和隐私协议
    backIOS() {
      this.$client.closeActivityIOS()
    },

    // 当月 开始 和 结束(时间戳)
    getMonthStartAndEnd(chooseTime) {
      let givenDate = new Date(chooseTime)
      let year = givenDate.getFullYear()
      let month = givenDate.getMonth()
      let startTime = new Date(year, month, 1).getTime()
      let endTime = new Date(year, month + 1, 1).getTime() - 1
      return {
        startTime: startTime,
        endTime: endTime
      }
    },

    // 本周 周一 和 周天(日期字符)
    getWeekStartAndEnd(date) {
      // 格式化日期为 yyyy-mm-dd
      function formatDate(date) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      const givenDate = new Date(date)
      const dayOfWeek = givenDate.getDay()
      // 本周周一
      const monday = new Date(givenDate)
      monday.setDate(givenDate.getDate() - ((dayOfWeek + 6) % 7))
      // 本周周日
      const sunday = new Date(monday)
      sunday.setDate(monday.getDate() + 6)

      return {
        monday: formatDate(monday),
        sunday: formatDate(sunday)
      }
    },

    // 时间处理(传的时间戳, 格式)
    handleMoment(time, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(time).format(format)
    },

    // s -> d:h:m
    transformSeconds1(seconds) {
      if (!seconds) return '0'
      const duration = moment.duration(seconds, 'seconds')
      return `${Math.floor(duration.asDays())}d:${duration.hours()}h:${duration.minutes()}m`
    },

    // s -> d h
    transformSeconds2(seconds) {
      if (!seconds) return '0'
      const duration = moment.duration(seconds, 'seconds')
      return `${Math.floor(duration.asDays())}d ${duration.hours()}h`
    },

    // s ->  h:m
    transformSeconds3(seconds) {
      if (!seconds) return '0'
      const duration = moment.duration(seconds, 'seconds')
      return `${duration.hours()}h:${duration.minutes()}m`
    },

    // s -> hms
    transformSeconds4(seconds) {
      if (!seconds) return '0'
      const duration = moment.duration(seconds, 'seconds')
      return `${duration.hours()}h${duration.minutes()}m${duration.seconds()}s`
    },

    // s -> h:m:s
    transformSeconds5(seconds) {
      if (!seconds) return '0'
      const duration = moment.duration(seconds, 'seconds')
      return `${duration.hours()}h:${duration.minutes()}m:${duration.seconds()}s`
    },

    handleCopy(val, msg) {
      if (val) {
        let createInput = document.createElement('input')
        createInput.value = val
        document.body.appendChild(createInput)
        // 选择对象
        createInput.select()
        // 执行浏览器复制命令
        document.execCommand('Copy')
        createInput.style.display = 'none'
        if (msg) {
          Client.showToast(msg)
        }
      }
    },

    // 是否为空对象
    isEmptyObject(obj) {
      return Object.keys(obj).length === 0
    },

    // 除以100 保留两位小数
    handleDiv100(val) {
      if (isEmpty(val)) {
        return val
      }
      return Decimal(val).div(Decimal(100)).toNumber()
    },

    // 数字千分位展示
    thousandthDigit(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },

    // prettier-ignore
    toFixedPrice (numArg) {
      try {
        return Number(numArg).toFixed(2)
      }
      catch (err) {
        return numArg
      }
    },

    myPlus(a, b) {
      if (isEmpty(a) || isEmpty(b)) {
        return ''
      }
      return Decimal(a).plus(Decimal(b)).toNumber()
    },

    myMinus(a, b) {
      if (isEmpty(a) || isEmpty(b)) {
        return ''
      }
      return Decimal(a).minus(Decimal(b)).toNumber()
    },

    myTimes(a, b) {
      if (isEmpty(a) || isEmpty(b)) {
        return ''
      }
      return Decimal(a).times(Decimal(b)).toNumber()
    },

    myDiv(a, b) {
      if (isEmpty(a) || isEmpty(b)) {
        return ''
      }
      return Decimal(a).div(Decimal(b)).toNumber()
    },

    // 替换文案中%s - 一个
    handleOneText(str, target, replacement) {
      return str.replace(target, replacement)
    },

    // 替换文案中%s - 两个
    handleTowText(str, target, replacement1, replacement2) {
      const firstIndex = str.indexOf(target)
      const lastIndex = str.lastIndexOf(target)
      // 确保至少有两个相同的子字符串
      if (firstIndex !== -1 && lastIndex !== -1 && firstIndex !== lastIndex) {
        // 用于替换第一个出现的目标子字符串
        str = str.substring(0, firstIndex) + replacement1 + str.substring(firstIndex + target.length)
        // 由于替换第一个子字符串可能会改变字符串长度，重新计算第二个目标的索引
        const adjustedLastIndex = str.indexOf(target, firstIndex + replacement1.length)
        // 用于替换第二个出现的目标子字符串
        str = str.substring(0, adjustedLastIndex) + replacement2 + str.substring(adjustedLastIndex + target.length)
      }
      return str
    },

    hasEmojiCharacter(substring) {
      const len = substring.length
      for (let i = 0; i < len; i++) {
        const hs = substring.charCodeAt(i)

        // 高代理项（High Surrogate）
        if (0xd800 <= hs && hs <= 0xdbff) {
          if (i + 1 < len) {
            const ls = substring.charCodeAt(i + 1)
            const uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000
            if (0x1d000 <= uc && uc <= 0x1f77f) {
              return true
            }
          }
        }
        // 组合符号（Combining Enclosing Keycap）
        else if (i + 1 < len) {
          const ls = substring.charCodeAt(i + 1)
          if (ls === 0x20e3) {
            return true
          }
        }
        // 其他常见 Emoji 字符区间
        else {
          if (
            (0x2100 <= hs && hs <= 0x27ff) ||
            (0x2b05 <= hs && hs <= 0x2b07) ||
            (0x2934 <= hs && hs <= 0x2935) ||
            (0x3297 <= hs && hs <= 0x3299) ||
            [0xa9, 0xae, 0x303d, 0x3030, 0x2b55, 0x2b1c, 0x2b1b, 0x2b50].includes(hs)
          ) {
            return true
          }
        }
      }

      return false
    },

    // 对比版本号
    compareVersion(v1, v2) {
      try {
        const parts1 = v1.split('.').map(Number)
        const parts2 = v2.split('.').map(Number)
        const len = Math.max(parts1.length, parts2.length)

        for (let i = 0; i < len; i++) {
          const num1 = parts1[i] || 0
          const num2 = parts2[i] || 0

          if (num1 > num2) return 1 // v1 更大
          if (num1 < num2) return -1 // v2 更大
        }

        return 0 // 相等
      } catch (error) {
        // 异常
        return -2
      }
    },

    // thinkingdata 上报
    traceAction(item) {
      try {
        if (window.ta) {
          window.ta.track('h5_page_track', item)
        }
        // 未初始化
        else {
          const uid = this.getUid()
          uid && addTraceStore(`thinkingdata_${uid}`, item)
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
    }
  },
  created() {
    this.getPackageName()
  },
}
export default GlobalMixins
